import { FC, useContext, useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  useMediaQuery,
} from "@material-ui/core";
import { useParams } from "react-router";
import Typography from "@material-ui/core/Typography";
import { useTheme } from "@material-ui/core";
import ProjectPoolHeading from "../Projects/ProjectPoolHeading";
import { useStyles } from "../Styles/LockTokenStyles";
import { useHistory } from "react-router-dom";
import Footer from "../SubComponents/Footer";
import { animateScroll as scroll } from "react-scroll";
import AdminHeader from "../SubComponents/AdminHeader";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import WaitModal from "../Modals/WaitModal";
import ExpireLink from "../../assets/images/ExpireLinkIcon.svg";
import BackButton from "../../helpers/BackButton";
import LockStakingInput from "./LockStakingInput";
import LockActionCard from "./LockActionCard";
import LockFAQ from "./LockFAQ";
import { Subscription } from "../../interfaces";
import ExplainPopover from "../Popover/ExplainPopover";
import resultBanner from "../../assets/images/ResultBanner.jpg";
import { useAccount } from "wagmi";
import { useWeb3 } from "../../services/web3/hooks/useWeb3";
import { formatDecimalNumber } from "../../utils/web3/formatBalance";
import PoolContext from "../../store/Pool/PoolContext";
import LearnContext from "../../store/Learn2/LearnContext";
import { filterQuizzesByPool } from "../../store/Learn2/LearnFunction";
import { FaPlay } from "react-icons/fa";
import { FaAward } from "react-icons/fa6";
import AuthContext from "../../store/Auth/AuthContext";
import KYCErrorModal from "../Gains/KYCErrorModal";
import HorizontalNonLinearStepper from "../ConnectWallet/WalletStepperNew";
import LockGainsModal from "../Gains/LockGainsModal";

const LockTokens: FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const { gainsBalance: totalGains } = useWeb3();
  const { createSubscription, totalTickets, waitModal } =
    useContext<any>(SubscriptionContext);
  const { getActivePool } = useContext<any>(PoolContext);
  const { quizzes, getPoolQuizzes } = useContext<any>(LearnContext);
  const { getProfileData } = useContext<any>(AuthContext);

  const { address: account } = useAccount();
  let { ids }: any = useParams();

  const [openWaitModal, setOpenWaitModal] = useState(true);
  const [openKYCModal, setOpenKYCModal] = useState(false);
  const [popover, setPopover] = useState("");
  const [gainsAnchor, setGainsAnchor] = useState<any>(null);
  const [firstTime, setFirstTime] = useState(false);
  const [ticketsAnchor, setTicketsAnchor] = useState<any>(null);
  const [projectData, setProejctData] = useState<any>(null);
  const [disableModals, setdisableModals] = useState(false);
  const [gainsBalance, setGainsBalance] = useState<number>(0);
  const [totalQuestions, setTotalQuestions] = useState<number>(0);
  const [showLockModal, toggleLockModal] = useState<boolean>(false);

  const titleRef = useRef<any>(null);
  const inputRef = useRef<any>(null);

  const [totalTokens, setTokens] = useState<number>(0);
  const [duration, setStakeDuration] = useState<number>(3);

  useEffect(() => {
    if (!localStorage.getItem("LockedPreviouslyVisited")) {
      localStorage.setItem("LockedPreviouslyVisited", "true");
      setFirstTime(true);
    }
  }, []);

  useEffect(() => {
    let poolQuizzes = filterQuizzesByPool(quizzes, ids);
    if (poolQuizzes.length === 0) getPoolQuizzes(ids);
    else {
      let total = 0;
      poolQuizzes.forEach((quiz: any) => {
        total += quiz.question.length;
      });
      setTotalQuestions(total);
    }
  }, [quizzes]);

  const handleLearning = () => {
    if (totalTickets === 0) {
      if (isActive) toggleLockModal(true);
      return;
    }
    if (getProfileData?.kycStatus !== "approved") {
      setOpenKYCModal(true);
      return;
    }
    // const pool = localStorage.getItem("activePool");
    // TODO: Get id from path instead of localStorage
    const pool = getActivePool();
    if (pool && pool.id) history.push(`/learn/${pool.id}`);
  };

  useEffect(() => {
    if (totalGains && totalGains.formatted) {
      let formattedBalance = formatDecimalNumber(totalGains.formatted);
      setGainsBalance(Number(formattedBalance));
    }
  }, [totalGains]);

  useEffect(() => {
    if (projectData) localStorage.setItem("projectName", projectData.name);
  }, [projectData]);

  const Expire = () => {
    return (
      <img
        src={ExpireLink}
        className="img-fluid vertical-align mr-8"
        alt="Gains"
      />
    );
  };

  const handleFinish = () => {
    setFirstTime(false);
    setPopover("");
    scroll.scrollToTop();
  };

  return (
    <>
      <AdminHeader
        ticketsPopRef={(e: any) => setTicketsAnchor(e.current)}
        gainsPopRef={(e: any) => setGainsAnchor(e.current)}
        restartTooltip={() => {
          setFirstTime(true);
          setPopover("gains");
        }}
      />

      <ExplainPopover
        id="simple-popover"
        open={firstTime && popover === "gains" && true}
        text={
          <p>
            This tab shows the total number of GAINS tokens you own.
            <br />
            1.The ones on your connected wallet (unlocked),
            <br />
            2.The ones you locked.
          </p>
        }
        anchorEl={gainsAnchor}
        title="Your GAINS"
        next={() => setPopover("tickets")}
        skip={handleFinish}
        handleClose={handleFinish}
      />

      <ExplainPopover
        id="simple-popover"
        open={popover === "tickets" && true}
        text={
          <p>
            To earn Lottery tickets:
            <br />
            1.Stake GAINS tokens,
            <br />
            2.Complete the quiz.
          </p>
        }
        anchorEl={ticketsAnchor}
        title="Tickets"
        next={() => setPopover("title")}
        skip={handleFinish}
        handleClose={handleFinish}
      />

      <ExplainPopover
        id="simple-popover"
        open={popover === "title" && true}
        text={`Staking tokens is necessary to win lottery tickets to have a chance to get whitelisted.
          `}
        anchorEl={titleRef.current}
        title="Stake GAINS"
        next={() => setPopover("input")}
        skip={handleFinish}
        handleClose={handleFinish}
      />

      <ExplainPopover
        id="simple-popover"
        open={popover === "input" && true}
        text={
          <p>
            1.Select the number of GAINS Tokens to stake,
            <br />
            2.Enter a duration.
          </p>
        }
        anchorEl={inputRef.current}
        title="How to stake? "
        skip={handleFinish}
        handleClose={handleFinish}
      />

      <HorizontalNonLinearStepper
        disableModals={disableModals}
        projectData={(data: any) => setProejctData(data[0])}
        projectChangeEnabled={true}
      />

      <Box mt={3}>
        <Divider />
      </Box>
      <Box
        className={classes.locktokens}
        mt={isActive ? 3 : 5}
        component="section"
      >
        <Box pb={isActive ? 3 : 2}>
          <Container fixed>
            <Grid
              container
              justifyContent={isActive ? "flex-start" : "space-between"}
              direction="row"
              alignItems="flex-end"
              spacing={4}
            >
              <Grid item md={12} lg={12} sm={12} xs={12}>
                <BackButton
                  route={`project/${ids}`}
                  whitelistedCompleted={false}
                />
                {!isActive && (
                  <>
                    <ProjectPoolHeading
                      titleRef={titleRef}
                      title1="Staking"
                      title2="Tokens"
                    />
                    <Typography
                      variant="body1"
                      color="secondary"
                      className="text-darkslate"
                      style={{ width: "100%" }}
                    >
                      <strong className="fw-bold">Stake more GAINS </strong>
                      for <strong className="fw-bold">longer</strong> to get
                      more lottery tickets and
                      <strong className="fw-bold"> bigger allocations. </strong>
                      To learn more,
                      <Typography component="span" color="primary">
                        {" "}
                        watch the explainer video.
                      </Typography>
                    </Typography>
                  </>
                )}
              </Grid>
            </Grid>
          </Container>
        </Box>
        <Container fixed>
          <Box
            display={"flex"}
            justifyContent={"center"}
            flexDirection={isActive ? "column" : "row"}
          >
            {!isActive && (
              <Grid
                direction={isActive ? "column" : "row"}
                container
                style={{
                  border: "2px solid rgba(48, 127, 226, 0.15)",
                  boxShadow: "0px 0px 20px rgba(0, 0, 0, 0.2)",
                  borderRadius: "8px",
                  marginRight: isActive ? "0" : "30px",
                  padding: "5px",
                }}
              >
                <LockStakingInput
                  gainsBalance={gainsBalance}
                  inputRef={inputRef}
                  createSubscription={createSubscription}
                  showStakeModalInfo={false}
                  totalTokens={totalTokens}
                  duration={duration}
                  setTotalTokens={(value: number) => setTokens(value)}
                  setDuration={(value: number) => setStakeDuration(value)}
                />
                <LockActionCard
                  gainsBalance={gainsBalance}
                  createSubscription={createSubscription}
                  totalTokens={totalTokens}
                  duration={duration}
                />
              </Grid>
            )}
            <div
              style={{
                width: isActive ? "100%" : "40%",
                display: "flex",
                alignItems: isActive ? "center" : "flex-start",
                flexDirection: "column",
                marginTop: "2px",
                justifyContent: "space-between",
              }}
            >
              {!isActive && (
                <img
                  src={resultBanner}
                  alt="YouMeme"
                  style={{ height: "276px" }}
                />
              )}
              <div
                // className="mt-12"
                style={{ minHeight: isActive ? "100px" : "135px" }}
              >
                <Typography className="fw-bold fs-18 mb-12 mt-12">
                  {projectData?.name}
                </Typography>
                <Typography className="mb-12 mt-12">
                  {projectData?.description}
                </Typography>
                <Button size="small" className={classes.durationBtn}>
                  <span style={{ fontSize: "12px" }}>
                    {totalQuestions} Questions
                  </span>
                </Button>
                <Button
                  size="small"
                  className={classes.durationBtn}
                  startIcon={<FaAward style={{ color: "#3eb8aa" }} />}
                >
                  <span style={{ fontSize: "12px" }}>
                    {totalTickets * 2} Tickets
                  </span>
                </Button>
              </div>
              <Box
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                flexDirection={"column"}
                width={"95%"}
              >
                <Button
                  size={"large"}
                  disabled={totalTickets < 1}
                  onClick={handleLearning}
                  classes={{
                    disabled: classes.disabledButton,
                    root: classes.QuizBtn,
                  }}
                  startIcon={
                    totalTickets < 1 ? (
                      ""
                    ) : (
                      <FaPlay style={{ fontSize: "12px" }} />
                    )
                  }
                >
                  {totalTickets < 1
                    ? "Requires Staking"
                    : "Apply for Whitelist"}
                </Button>
                {isActive && (
                  <Button
                    size={"large"}
                    onClick={() => toggleLockModal(true)}
                    variant="outlined"
                    fullWidth
                    style={{
                      marginTop: "20px",
                    }}
                  >
                    {totalTickets < 1 ? "Stake GAINS" : "Stake More GAINS"}
                  </Button>
                )}
              </Box>
            </div>
          </Box>
        </Container>
        <Container fixed>
          <Box
            mt={4}
            mb={totalTickets === 0 ? 2 : 7}
            display="flex"
            flexDirection="row-reverse"
          ></Box>

          {/* <Divider className={classes.divider} /> */}
          {waitModal === true && (
            <WaitModal open={openWaitModal} setOpen={setOpenWaitModal} />
          )}
          {openKYCModal && (
            <KYCErrorModal open={openKYCModal} setOpen={setOpenKYCModal} />
          )}
          {showLockModal && (
            <LockGainsModal
              open={showLockModal}
              toggleModal={toggleLockModal}
            />
          )}
        </Container>
      </Box>

      {/* <Container fixed>
        <Box className="mb-16 mt-12">
          <LockFAQ />
        </Box>
      </Container> */}
      <Footer />
    </>
  );
};

export default LockTokens;
